export default __webpack_public_path__ + "static/media/JAVA_ico.63778a41.svg";